import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  useUser,
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
  useEmpResgiterMutation,
  useIndustries,
} from "../../actions/authActions";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countryCode, setCountryCode] = useState(null);
  const [loadingToapi, setLoadingToapi] = useState(false);
  const userData = useSelector((state) => state.app.userData.userData);
  const userId = localStorage.getItem("userId");
  const {
    data: userprofile,
    isLoading: isLoadingprefilled,
    isError: isErrorprefilled,
    error: errorprefilled,
  } = useUser(userId);
  const [select, setSelect] = useState({
    companyIndusrty: null,
  });
  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    values: {
      empName: userprofile?.first_name + " " + userprofile?.last_name || "",
      email: userprofile?.email || "",
    },
    defaultValues: {
      empName: userprofile?.first_name + " " + userprofile?.last_name || "",
      email: userprofile?.email || "",
      city: "",
      postCode: "",
      phone: "",
      nightphone: "",
      address: "",
      companyWebsite: "",
      companySize: "",
      registtation_Number: "",
      contact_name: "",
    },
  });
  useEffect(() => {
    if (
      !isLoadingprefilled &&
      userprofile &&
      Object.keys(userprofile).length > 0
    ) {
      setValue(
        "phone",
        userprofile?.mobile_num ? String(userprofile?.mobile_num) : ""
      );
      setValue(
        "city_id",
        userprofile?.city_id ? String(userprofile?.city_id) : ""
      );
      setValue(
        "countries",
        userprofile?.country_id ? String(userprofile?.country_id) : ""
      );
      setValue(
        "state_id",
        userprofile?.state_id ? String(userprofile?.state_id) : ""
      );
    }
  }, [userprofile, isLoadingprefilled, setValue]);
  const { data: dropdowns, isLoading, isError, error } = useDropdown();
  const selectedCountry = watch("countries");
  const selectedState = watch("state_id");
  const {
    data: industriesData,
    isLoading: isLoadingIndustries,
    isError: isErrorIndustries,
    error: errorIndustries,
  } = useIndustries();
  console.log("industriesData", industriesData);

  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorstates,
    error: errorstates,
  } = useStatesDropdowns(selectedCountry);
  const { data: cities, isLoading: citiesisLoading } =
    UsecitiesDropdowns(selectedState);
  const isLogin = true;
  const mutation = useEmpResgiterMutation(
    false,
    setLoadingToapi,
    navigate,
    dispatch,
    isLogin
  );
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Countries: {error.message}
        </p>
      </div>
    );
  }
  if (isErrorprefilled) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Countries: {errorprefilled.message}
        </p>
      </div>
    );
  }
  if (isErrorstates) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading States: {errorstates.message}
        </p>
      </div>
    );
  }
  if (isErrorIndustries) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading States: {errorIndustries.message}
        </p>
      </div>
    );
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const userId = localStorage.getItem("userId");
    const apiData = new FormData();
    apiData.append(
      "name",
      data?.empName || userprofile?.first_name + " " + userprofile?.last_name
    );
    apiData.append("email", data.email || userprofile?.email);
    apiData.append("country_id", data.countries || userprofile?.country_id);
    apiData.append("country_code", countryCode || userprofile?.country_code);
    apiData.append("state_id", data.state_id || userprofile?.state_id);
    apiData.append("city_id", data.city_id || userprofile?.city_id);
    apiData.append("address_line_1", data.address);
    apiData.append("zip_code", data.postCode);
    apiData.append("user_id", userId);
    apiData.append("phone", data.phone);
    apiData.append("website", data.companyWebsite);
    apiData.append("industry_id", select?.companyIndusrty);
    apiData.append("no_of_employees", data.companySize);
    apiData.append("registration_number", data.registtation_Number);
    apiData.append("contact_person", data.contact_name);
    mutation.mutate(apiData);
  };
  return {
    setCountryCode,
    loadingToapi,
    dropdowns,
    isLoading,
    register,
    handleSubmit,
    onSubmit,
    errors,
    control,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    industriesData,
    isLoadingIndustries,
    select,
    handleDropdwonSelect,
    setValue,
    isLoadingprefilled,
    userprofile,
  };
};
